import { Component, effect, inject, input } from '@angular/core';
import { ProjectModel } from '../../../../../core/models/project/project.model';
import { ProjectDataService } from '../../state-and-data-handling/project-data.service';
import { SeriesLabelsContentArgs } from '@progress/kendo-angular-charts';
import { ProjectExpenditureChartTransformerService } from '../services/project-expenditure-chart-transformer.service';
import { BarChartData } from '../../../../../shared/data-types/chart-types';
import { Interval } from 'date-fns';
import { TimeBlockWithTask } from '../../../../../shared/data-types/shared-time-block-types';

@Component({
  selector: 'app-project-expenditure-chart',
  templateUrl: './project-expenditure-chart.component.html',
  standalone: false,
})
export class ProjectExpenditureChartComponent {
  timeBlocksWithTask = input.required<readonly TimeBlockWithTask[]>();
  timeRange = input.required<Interval>();

  public data: { data: BarChartData[] }[] = [];
  private readonly projectExpenditureChartTransformerService = inject(
    ProjectExpenditureChartTransformerService,
  );
  private readonly projectDataService = inject(ProjectDataService);

  constructor() {
    // React to input changes
    effect(() => {
      const timeBlocks = this.timeBlocksWithTask();
      const timeRange = this.timeRange();

      if (timeBlocks && timeRange) {
        const project = this.projectDataService.getProjectClone();
        this.createBarData(project);
      }
    });
  }

  public labelContent = (args: SeriesLabelsContentArgs): string => {
    return args.dataItem?.label ? args.dataItem.label : '';
  };

  private createBarData(project: ProjectModel): void {
    this.data = this.projectExpenditureChartTransformerService.transformFeesToChartData(
      project,
      this.timeRange(),
      this.timeBlocksWithTask(),
    );
  }
}
